export default __webpack_public_path__ + "static/media/18.9aa9c227.svg";